import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { NavigationStart, Router } from '@angular/router';
import { HomeService } from '../_services/home.service';
import { ErrorMessageService } from '../services/error-message.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

type NewType = Router;

@Component({
  selector: 'app-property-slide',
  templateUrl: './property-slide.component.html',
  styleUrls: ['./property-slide.component.scss'],
  providers: [CurrencyPipe]
})
export class PropertySlideComponent implements OnInit {
  @Output() payloadEvent = new EventEmitter<any>();
  hasMore: boolean = false;
  isExpanded: boolean = true;
  selectedMinValue: number | null = null;
  selectedMaxValue: string = '';
  selectedBudget: string = '';
  panelOpenState = false;
  userfilter: string[] = [];
  showAllBedrooms: boolean = false;
  selectedType: string[] = [];
  isFilterSidebarOpen = false;
  searchAreaQuery: { area: string } | string | null = null;
  AreaDataList: any[] = [];
  showCitySuggestions: boolean = false;
  allstateId: any;

  payload: any = {};
  private routerSubscription: Subscription;
  private currentUrl: string = '';
  constructor(private cdr: ChangeDetectorRef, private router: Router, private homeService: HomeService, private toastr: ToastrService, private errorMessageService: ErrorMessageService) {

    this.currentUrl = this.router.url;

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const nextUrl = event.url;

        // ✅ Check if navigating away from /home-property
        if (this.currentUrl.includes('/home-property') && !nextUrl.includes('/home-property')) {
          localStorage.removeItem('selectedBudgetValue');
        }
      }
    });
  }

  propertyTypes = [
    { name: 'Residential', selected: false },
    { name: 'Commercial', selected: false },
  ];

  budgetOptions = [
    { label: '1,000 - 5,000', value: '1000,5000' },
    { label: '5,000 - 10,000', value: '5000,10000' },
    { label: '10,000 - 20,000', value: '10000,20000' },
    { label: '20,000 - 50,000', value: '20000,50000' },
    { label: '50,000 - 1 Lakh', value: '50000,100000' },
    { label: '1 Lakh - 2 Lakh', value: '100000,200000' },
    { label: '2 Lakh - 5 Lakh', value: '200000,500000' },
    { label: '5 Lakh+', value: '500000,700000' }
  ];

  toggleMore() {
    this.hasMore = !this.hasMore;
  }

  // selectPropertyType(propertyType) {
  //   propertyType.selected = !propertyType.selected;

  //   if (propertyType.selected) {
  //     this.userfilter.push(propertyType.name);
  //     if (!this.selectedType.includes("type")) {
  //       this.selectedType.push("type");
  //     }
  //   } else {
  //     this.userfilter = this.userfilter.filter(name => name !== propertyType.name);
  //     if (this.userfilter.filter(f => this.propertyTypes.find(pt => pt.name === f)).length === 0) {
  //       this.selectedType = this.selectedType.filter(type => type !== "type");
  //     }
  //   }

  //   this.saveSelectedTypesToLocalStorage();
  //   this.updatePayload();
  //   this.cdr.detectChanges();
  // }
  selectPropertyType(propertyType) {
    // Deselect all property types first
    this.propertyTypes.forEach(pt => {
      pt.selected = false;
    });

    // Select only the clicked one
    propertyType.selected = true;

    // Update filters
    this.userfilter = [propertyType.name];

    // Ensure 'type' is in selectedType
    this.selectedType = ['type'];

    // Save to localStorage and update payload
    this.saveSelectedTypesToLocalStorage();
    this.updatePayload();
    this.cdr.detectChanges();
  }


  saveSelectedTypesToLocalStorage() {
    const selectedTypes = this.propertyTypes.filter(pt => pt.selected).map(pt => pt.name);
    localStorage.setItem('search_type', selectedTypes.join(','));
  }

  onBudgetChange() {
    const selectedLabel = this.budgetOptions.find(opt => opt.value === this.selectedMaxValue)?.label;
    if (selectedLabel) {
      this.selectedBudget = selectedLabel;

      // Remove any previous budget
      this.userfilter = this.userfilter.filter(item => !item.includes('-') && !item.includes('Lakh'));
      this.userfilter.push(selectedLabel);

      if (!this.selectedType.includes('budget')) {
        this.selectedType.push('budget');
      }

      localStorage.setItem('selectedBudgetValue', this.selectedMaxValue);
    }
    this.updatePayload();
    this.cdr.detectChanges();
  }
  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  removeBudget() {
    this.selectedBudget = '';
    this.selectedMinValue = null;
    this.selectedMaxValue = '';

    this.userfilter = this.userfilter.filter(item => !item.includes('-') && !item.includes('Lakh'));
    this.selectedType = this.selectedType.filter(t => t !== 'budget');

    localStorage.removeItem('selectedBudgetValue');

    this.updatePayload();
    this.cdr.detectChanges();
  }

  removeFilter(filter: string) {
    this.userfilter = this.userfilter.filter(name => name !== filter);

    // Check if filter is from propertyType
    this.propertyTypes.forEach(pt => {
      if (pt.name === filter) pt.selected = false;
    });

    // Check if filter is budget
    const budgetMatch = this.budgetOptions.find(b => b.label === filter);
    if (budgetMatch) {
      this.selectedMaxValue = '';
      this.selectedBudget = '';
      this.selectedType = this.selectedType.filter(t => t !== 'budget');
      localStorage.removeItem('selectedBudgetValue');
    }

    this.updatePayload();
    this.cdr.detectChanges();
  }

  applyFilter() {
    console.log('Final store data', this.payload);
    this.payloadEvent.emit(this.payload);
    this.isFilterSidebarOpen = false;
  }

  toggleShowAllBedrooms() {
    this.showAllBedrooms = !this.showAllBedrooms;
  }

  ngOnInit(): void {
    const savedSearchType = localStorage.getItem('search_type');
    const selectedBudgetValue = localStorage.getItem('selectedBudgetValue');
    const savedArea = localStorage.getItem('search_query');

    this.searchArea('')
    if (savedSearchType) {
      const selectedTypes = savedSearchType.split(',');
      this.propertyTypes.forEach(propertyType => {
        if (selectedTypes.includes(propertyType.name)) {
          propertyType.selected = true;
          this.userfilter.push(propertyType.name);
          if (!this.selectedType.includes("type")) {
            this.selectedType.push("type");
          }
        }
      });
    }

    if (selectedBudgetValue) {
      this.selectedMaxValue = selectedBudgetValue;
      const selectedLabel = this.budgetOptions.find(opt => opt.value === selectedBudgetValue)?.label;
      if (selectedLabel) {
        this.selectedBudget = selectedLabel;
        this.userfilter.push(selectedLabel);
        if (!this.selectedType.includes('budget')) {
          this.selectedType.push('budget');
        }
      }
    }
    if (savedArea) {
      this.searchArea(savedArea, true);
    }
    const savedFilters = localStorage.getItem('Filter');
    if (savedFilters) {
      this.payload = JSON.parse(savedFilters);
    }
  }

  clearSelection() {
    this.propertyTypes.forEach(pt => pt.selected = false);
    this.userfilter = [];
    this.selectedType = [];
    this.selectedMinValue = null;
    this.selectedMaxValue = '';
    this.selectedBudget = '';
    this.searchAreaQuery = '';
    localStorage.removeItem('Filter');
    localStorage.removeItem('search_type');
    localStorage.removeItem('selectedBudgetValue');
    localStorage.removeItem('search_query');
    this.updatePayload();
  }
  setarea() {
    const savedArea = localStorage.getItem('search_query');
    if (savedArea) {
      this.searchArea(savedArea, true);
    }
  }
  updatePayload() {
    this.payload = {
      filterConditions: [],
      sortConditions: [],
      searchValue: null,
      page: 0,
      size: 10
    };
    this.searchArea('');
    const selectedPropertyTypes = this.propertyTypes.filter(pt => pt.selected).map(pt => pt.name);
    if (selectedPropertyTypes.length > 0) {
      this.payload.filterConditions.push({
        filterName: "type",
        filterValue: selectedPropertyTypes.join(',')
      });
    }

    if (this.selectedMaxValue) {
      this.payload.filterConditions.push({
        filterName: "budget",
        filterValue: this.selectedMaxValue
      });
    }

    localStorage.setItem('Filter', JSON.stringify(this.payload));

    // Force reload
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);

    this.payloadEvent.emit(this.payload);
  }

  toggleFilterSidebar() {
    this.isFilterSidebarOpen = !this.isFilterSidebarOpen;
  }





  searchArea(searchTerm: string, isInit: boolean = false) {
    const selectedCityId = localStorage.getItem('selectedCityId');
    if (!selectedCityId) return;

    this.homeService.getPropertyByCityIdAndArea(selectedCityId, searchTerm).subscribe(
      (response: any) => {
        this.AreaDataList = response.status === 'SUCCESS' ? response.payload : [];

        if (isInit && searchTerm) {
          const matchedArea = this.AreaDataList.find(item =>
            item.area.toLowerCase() === searchTerm.toLowerCase()
          );
          if (matchedArea) {
            this.searchAreaQuery = matchedArea;
            this.payload.searchValue = matchedArea.area;
          }
        }
      },
      (error) => {
        this.AreaDataList = [];
        const message = error?.error?.message || 'Failed to fetch city data';
        const errorMessage = this.errorMessageService.getErrorMessage(message);
        this.toastr.error(errorMessage, 'Error');
      }
    );
  }

  selectedCity: string | null = null;
  allCities: string[] = [];
  filteredCities: string[] = [...this.allCities];

  selectArea(area: any) {
    this.searchAreaQuery = area;
    localStorage.setItem('search_query', area.area);
    this.payload.searchValue = area.area;
    this.searchArea('')
    this.updatePayload();
  }


  compareAreas = (a: any, b: any): boolean => {
    return a && b && a.area === b.area;
  };



  onAreaInputClick() {
    this.clearSearch();
    if (this.AreaDataList.length > 0) {
      this.showCitySuggestions = true;
    }
  }

  clearSearch() {
    this.searchAreaQuery = '';
    this.showCitySuggestions = false;
  }



}
